import React from 'react';
import { Button, ButtonProps, BasicModal } from '@life-line-lab/components-react';

import './confirm-modal.scss';

interface ConfirmModalProps {
  type?: 'danger' | 'warning' | 'success' | 'info';
  renderHeader?: React.ReactNode,
  cancelButtonProps?: ButtonProps,
  confirmButtonProps?: ButtonProps,
  isOpen: boolean;
  onConfirm?: () => void;
  onCancel?: () => void;
  onClose: () => void;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
  type='danger',
  renderHeader,
  cancelButtonProps,
  confirmButtonProps,
  children,
  isOpen,
  onConfirm,
  onCancel,
  onClose
}) => {
  return (
    <BasicModal
      className="confirm-modal"
      isOpen={isOpen}
      isClosable={false}
      isMaskClosable={false}
      onClose={onClose}
    >
      {renderHeader &&
        <div className="confirm-modal--header">
          {renderHeader}
        </div>
      }

      <div className="confirm-modal--body">
        {children}
      </div>

      <div className="confirm-modal--actions">
        <Button type="link" size="large" { ...cancelButtonProps } onClick={onCancel} />
        <Button size="large" { ...confirmButtonProps } onClick={onConfirm} />
      </div>
    </BasicModal>
  )
}

export default ConfirmModal;
